import React, { createContext, useContext } from "react";
import { Notifier } from "@airbrake/browser";

const projectId = import.meta.env.VITE_AIRBRAKE_PROJECT_ID;
const projectKey = import.meta.env.VITE_AIRBRAKE_PROJECT_KEY;

const airbrake = new Notifier({
  projectId,
  projectKey,
  environment: process.env.NODE_ENV,
});

airbrake.addFilter((notice) => {
  // Filter logic can be centralized here if needed
  if (process.env.NODE_ENV === "development") {
    console.log("Airbrake notice in development:", notice);
    // Optionally return null to prevent sending in dev
    // return null; 
  }
  return notice;
});

const AirbrakeContext = createContext(null);

export const AirbrakeProvider = ({ children }) => {
  return (
    <AirbrakeContext.Provider value={airbrake}>
      {children}
    </AirbrakeContext.Provider>
  );
};

export const useAirbrake = () => {
  const context = useContext(AirbrakeContext);
  if (context === null) {
    throw new Error("useAirbrake must be used within an AirbrakeProvider");
  }
  return context;
}; 